// extracted by mini-css-extract-plugin
export var typingIndicator = "_rb-0";